import * as React from 'react'
import Select from 'react-select'
import { DrawingMode } from './GoinZonesPane'

interface IDrawingToolsButtonsProps {
  map: any
  onDrawingToolSelect: (tool: DrawingMode) => void
  drawBy: DrawingMode
  adding: boolean
  address: string
  onLocationAutocompleteChange: (address: any) => void
  onLocationAutocompleteDropdownSelect: (address: any) => void
  loadKmlFile: (file: any) => void
  toAdd: string
}

class DrawingToolsButtons extends React.Component<IDrawingToolsButtonsProps, any> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    const PlacesAutocompleteContain = require('react-places-autocomplete')
    const PlacesAutocomplete = PlacesAutocompleteContain.default

    const modeOptions = [
      { value: DrawingMode.ZONE, label: 'Draw Geo Zone' },
      { value: DrawingMode.PLACE, label: 'Place - Comming soon!' },
      { value: DrawingMode.CITY, label: 'City' },
      { value: DrawingMode.COUNTY, label: 'County' },
      { value: DrawingMode.STATE, label: 'State' },
      { value: DrawingMode.KMLFILE, label: 'KML File' }
    ]

    const selectedOption = modeOptions.filter(m => m.value === this.props.drawBy)[0]

    return (
      <div className='mb1'>
        <Select onChange={this.handleDrawChange} value={selectedOption} options={modeOptions} />
        {this.props.drawBy !== DrawingMode.ZONE && this.props.drawBy !== DrawingMode.KMLFILE && (
          <div className='mt1'>
            <PlacesAutocomplete
              value={this.props.address}
              onChange={this.props.onLocationAutocompleteChange}
              onSelect={this.props.onLocationAutocompleteDropdownSelect}
              searchOptions={{
                componentRestrictions: {
                  country: 'us'
                },
                location: this.props.map.getCenter(),
                types: this.getLocationAutocompleteType(),
                radius: 2000
              }}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }: any) => (
                <div className='relative'>
                  <input
                    {...getInputProps({
                      placeholder: 'Search ' + this.props.drawBy + ' ...',
                      className: 'location-search-input p1'
                    })}
                  />
                  <div
                    className='autocomplete-dropdown-container absolute w100'
                    style={{ boxShadow: '0px 0px 2px grey' }}
                  >
                    {this.filterResults(suggestions, getSuggestionItemProps)}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>
          </div>
        )}
        {this.props.drawBy === DrawingMode.KMLFILE && (
          <input accept='.kml' type='file' name='kmlfile-input' className='p1' onChange={this.kmlFileLoad} />
        )}
      </div>
    )
  }

  private kmlFileLoad = (event: any) => {
    const file = event.target.files[0]
    this.props.loadKmlFile(file)
  }

  private handleDrawChange = (event: any) => {
    let drawMode: DrawingMode = event.value
    if (this.props.toAdd === 'pick up/drop off point' && drawMode === DrawingMode.ZONE) {
      drawMode = DrawingMode.PLACE
    }
    this.props.onDrawingToolSelect(drawMode)
  }

  private getLocationAutocompleteType = () => {
    switch (this.props.drawBy) {
      case DrawingMode.PLACE:
        return ['address']
      case DrawingMode.CITY:
        return ['(cities)']
      case DrawingMode.COUNTY:
        return ['(regions)']
      case DrawingMode.STATE:
        return ['(regions)']

      default:
        return ['(cities)']
    }
  }

  private filterResults = (suggestions: any, getSuggestionItemProps: any) => {
    const hasType = (type: string, lst: any[]) => {
      for (const i of Object.keys(lst)) {
        if (lst[i] === type) {
          return true
        }
      }
      return false
    }
    const realSuggestions: any[] = []
    for (const i of Object.keys(suggestions)) {
      const sug = suggestions[i]
      if (this.props.drawBy === DrawingMode.STATE) {
        if (hasType('administrative_area_level_1', sug.types)) {
          realSuggestions.push(sug)
        }
      }
      if (this.props.drawBy === DrawingMode.COUNTY) {
        if (hasType('administrative_area_level_2', sug.types)) {
          realSuggestions.push(sug)
        }
      }
      if (this.props.drawBy === DrawingMode.CITY) {
        if (hasType('locality', sug.types)) {
          realSuggestions.push(sug)
        }
      }
      if (this.props.drawBy === DrawingMode.PLACE) {
        realSuggestions.push(sug)
      }
    }

    return realSuggestions.map((suggestion: any) => {
      const className = 'w100' + (suggestion.active ? 'suggestion-item--active' : 'suggestion-item')
      // inline style for demonstration purpose
      const style = suggestion.active
        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
        : { backgroundColor: '#ffffff', cursor: 'pointer' }

      return (
        <div
          key={suggestion}
          {...getSuggestionItemProps(suggestion, {
            className,
            style
          })}
        >
          <span>{suggestion.description}</span>
        </div>
      )
    })
  }
}

export default DrawingToolsButtons



// WEBPACK FOOTER //
// ./src/components/services/edit/goinzones/DrawingToolsButtons.tsx